import { MyStoreStyled, SelectStoreButtonWrapper } from './SelectStoreButton.style';
import Button from 'components/Forms/Button/Button';
import { useTypedTranslationFunction } from 'hooks/typescript/UseTypedTranslationFunction';
import { SimpleCheckmarkIcon } from 'public/svg/IconsSvg';
import { useCallback, useState } from 'react';
import { usePersistStore } from 'store/usePersistStore';

type StoreBenefitsProps = {
    storeUuid: string;
};

const SelectStoreButton: FC<StoreBenefitsProps> = ({ storeUuid }) => {
    const t = useTypedTranslationFunction();
    const { updateDefaultStoreUuidState } = usePersistStore((s) => s);

    const { defaultStoreUuid } = usePersistStore((s) => s);
    const [isDefaultStore, setDefaultStore] = useState(storeUuid === defaultStoreUuid);

    const setDefaultStoreHandler = useCallback(
        (storeUuid: string | null) => () => {
            if (storeUuid === null) {
                setDefaultStore(false);
                updateDefaultStoreUuidState(null);

                return;
            }

            setDefaultStore(true);
            updateDefaultStoreUuidState(storeUuid);
        },
        [updateDefaultStoreUuidState],
    );

    if (isDefaultStore) {
        return (
            <SelectStoreButtonWrapper>
                <MyStoreStyled>
                    <SimpleCheckmarkIcon />
                    {t('My store')}
                </MyStoreStyled>
                <Button type="button" size="smallNarrow" onClick={setDefaultStoreHandler(null)}>
                    {t('Remove as my store')}
                </Button>
            </SelectStoreButtonWrapper>
        );
    }

    return (
        <SelectStoreButtonWrapper>
            <Button type="button" size="smallNarrow" onClick={setDefaultStoreHandler(storeUuid)}>
                {t('Set as my store')}
            </Button>
        </SelectStoreButtonWrapper>
    );
};

export default SelectStoreButton;
